module.exports = flarum.core.compat['components/LogInButtons'];